module.exports = __webpack_public_path__ + "assets/group-2eb48b.svg";